module.exports = __webpack_public_path__ + "static/img/kapipo-details.b1a5851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kapipo-details.png
// module id = LFPS
// module chunks = 0